import { Directive } from "@angular/core";

@Directive({
	selector: "ng-template[tgToolbarRightControls]",
})
export class TgToolbarRightControlsDirective {
	constructor() {}
}
